import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import moment, { parseZone } from "moment";
import Countdown from "react-countdown";
import ApiServer from "../../helpers/Api_help";
import "./evehome.css";
import { Form } from "reactstrap";
import { Modal, Button, Carousel } from "react-bootstrap";
import { fetchSelectedEventVenue,fetchUserDetails } from "../../features/Event/EventTBSlice.jsx";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

const TicketSlider = ({ UpcomingData, openBookingModal }) => {
  const User_Id_ = JSON.parse(localStorage.getItem("user_id"));
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedVenue, setSelectedVenue] = useState(null);
  const nav = useNavigate();
  const [carouselInterval, setCarouselInterval] = useState(2000);

  const dispatch =useDispatch()
  const [modalMember, SetModalMember] = useState(false);
  // Random component
  const Completionist = ({ countDown }) => (
    <span /* style={countDown} */ className="countDown">Today's Event!</span>
  );
const isEventOver = (event) => {
  return moment().isAfter(moment.parseZone(event.start_date));
};

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if ((days < 0 && hours < 0 && minutes < 0 && seconds < 0) || completed) {
      return <Completionist /* countDown={countDown}  */ />;
    } else {
      return (
        <ul
          /*  style={countDown} */
          className="d-flex justify-content-center countDown"
        >
          <li className="countdown_element" style={{ fontStyle: "normal" }}>
            <span>{days}</span>
            <span className="letters"> Days</span>
          </li>
          <li className="countdown_element" style={{ fontStyle: "normal" }}>
            <span>{hours}</span>
            <span className="letters"> Hours</span>
          </li>
          <li className="countdown_element" style={{ fontStyle: "normal" }}>
            <span>{minutes}</span>
            <span className="letters"> Mins</span>
          </li>
          <li className="countdown_element" style={{ fontStyle: "normal" }}>
            <span>{seconds}</span>
            <span className="letters"> Secs</span>
          </li>
        </ul>
      );
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      category: "",
    },
    validationSchema: Yup.object({
      category: Yup.string().required(" select Your Category type "),
    }),
    onSubmit: (values, actions) => {
      if (values.category === "Member") {
        alert("Login and enjoy membership price for ticket booking");
        nav("/login");
      } else {
        if (!selectedEvent || !selectedVenue) return;

const url = `${ApiServer}view-pug?eventId=${selectedEvent._id}&venueId=${selectedVenue._id}&memberID=${User_Id_ || ""}`;

        openBookingModal(url);
      }

      actions.resetForm();
      SetModalMember(false);
    },
  });

  const SelectEvent = (e, data) => {
    console.log("edit");
    e.preventDefault();
    localStorage.setItem("SelectEvent", data);
    // nav("/EventsDetails")
  };
  const shouldShowBookNow = (venue) => {
    const hasTicketPrice = venue?.ticket_pricing?.pricing?.length > 0;
    const hasFoodPrice = venue?.food_pricing?.length > 0;

    return (
      venue?._id !== "65278e6a02c022ad330b9258" &&
      (hasTicketPrice || hasFoodPrice)
    );
  };
  return (
    <>
      <div className="col-12">
        {UpcomingData && UpcomingData.length > 0 ? (
          // <Carousel indicators controls interval={null}>
          <Carousel
            indicators
            controls
            interval={carouselInterval}
            pause={false} // we control pause manually
            touch={true} //  enables finger swipe
            wrap={true}
            onTouchStart={() => setCarouselInterval(null)} //  pause on finger hold
            onTouchEnd={() => setCarouselInterval(2000)} //  resume after release
            onMouseEnter={() => setCarouselInterval(null)} // desktop pause
            onMouseLeave={() => setCarouselInterval(2000)}
          >
            {/* {UpcomingData.map((item, inde) => ( */}
            {UpcomingData
  .filter(item => !isEventOver(item))
  .map((item, inde) => (
              <Carousel.Item key={inde}>
                <div
                  style={{
                    paddingTop: 10,
                    paddingBottom: 10,
                    width: "100%",
                  }}
                >
                  <div className="container">
                    {/* CONTENT BOX */}
                    <div
                      className="bg-secondary"
                      style={{
                        padding: "30px 20px",
                        borderRadius: "12px",
                      }}
                    >
                      {/* CENTER CONTENT */}
                      <div className="d-flex justify-content-center">
                        <div
                          style={{
                            width: "100%",
                            maxWidth: "1100px",
                          }}
                        >
                          {/* EVENT NAME */}
                          <div className="text-center mt-3">
                            <Link
                              to="/UpComingEvent"
                              className="fw-bold text-dark d-block mb-3"
                              style={{
                                fontSize: "clamp(22px, 3vw, 30px)",
                                lineHeight: 1.2,
                              }}
                            >
                              {item.name}
                            </Link>

                            {/* EVENT IMAGE */}
                            <img
                              src={`${ApiServer}assets/event_cover/${item.image_name || item.image_url}`}
                              alt="event"
                              onClick={(e) => SelectEvent(e, item._id)}
                              style={{
                                width: "100%",
                                height: "auto",
                                maxHeight: "400px",
                                objectFit: "contain",
                                borderRadius: "10px",
                                cursor: "pointer",
                              }}
                            />
                          </div>

                          {(item.venues || []).map((venue, ind4) => {
                            return (
                              <div className="mt-3" key={ind4}>
                                <div style={{ textAlign: "center" }}>
                                  <span
                                    className="text-white "
                                    // style={{ fontSize: 25, lineHeight: 0.7 }}
                                    style={{
                                      fontSize: "clamp(14px, 3.5vw, 22px)",
                                      lineHeight: 1.2,
                                    }}
                                  >
                                    {venue.venue}
                                  </span>
                                </div>
                                <div
                                  className="my-2 "
                                  style={{ textAlign: "center" }}
                                >
                                  <span
                                    className="text-white"
                                    // style={{ fontSize: 20, lineHeight: 0.7 }}
                                    style={{
                                      fontSize: "clamp(12px, 3vw, 18px)",
                                      lineHeight: 1.4,
                                    }}
                                  >
                                    {moment
                                      .parseZone(venue.start_datetime)
                                      .format("LLLL")}
                                  </span>
                                </div>

                                {(venue.ticket_allocations || []).map(
                                  (allocation) => {
                                    if (
                                      allocation.booking_type === "early bird"
                                    ) {
                                      return (
                                        <div
                                          key={allocation._id}
                                          style={{
                                            color: "#333333", // Dark color
                                            // fontSize: "18px",
                                            textAlign: "center",
                                            fontSize: "clamp(12px, 3vw, 16px)",

                                            marginBottom: "10px",
                                            animation:
                                              "blink 1s steps(5, start) infinite",
                                            WebkitAnimation:
                                              "blink 1s steps(5, start) infinite", // For Safari
                                          }}
                                        >
                                          Early Bird Offer ends on{" "}
                                          {moment
                                            .parseZone(allocation.end_date)
                                            .format("MMMM Do, YYYY")}
                                        </div>
                                      );
                                    }
                                    return null;
                                  },
                                )}

                                <div className="d-flex justify-content-center">
                                  {shouldShowBookNow(venue) && !isEventOver(item) && (
                                    <Button
                                      className="btn btn-sm border-0 bg-warning me-2"
                                      onClick={async (e) => {
                                        e.preventDefault();

                                        setSelectedEvent(item);
                                        setSelectedVenue(venue);

                                              const actualMemberID = User_Id_ && User_Id_._id ? User_Id_._id : (User_Id_ || "");

                                        localStorage.setItem(
                                          "SelectVenue",
                                          JSON.stringify({
                                            _id: venue._id,
                                            event_name: item?.name,
                                            venue_name: venue?.venue,
                                            event_date: item?.start_date,
                                            venue_date: venue?.start_datetime,
                                          }),
                                        );

                                        localStorage.setItem(
                                          "SelectedEventMeta",
                                          JSON.stringify({
                                            _id: item._id,
                                          }),
                                        );

                                        if (!User_Id_) {
                                          SetModalMember(true);
                                          return;
                                        }
                                           await dispatch(fetchUserDetails(actualMemberID))

                                        if (
                                          item._id ===
                                          "6596888d1705690eaaa9763a"
                                        ) {
                                          nav("/ticketbookingfetna");
                                          return;
                                        }

                                        // const url = `${ApiServer}view-pug?eventId=${item._id}&venueId=${venue._id}`;
                                        const url = `${ApiServer}view-pug?eventId=${item._id}&venueId=${venue._id}&memberID=${actualMemberID}`;
                                        // openBookingModal(url);
                                        // ✅ CALL LIMIT CHECK API
try {
  const res = await fetch(`${ApiServer}manage-booking-user/check-booking-limit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      master_venue_id: venue._id,
      memberID: actualMemberID || null,
    }),
  });

 try {
  // ❌ remove limit check completely OR keep only for logging
  openBookingModal(url);
} catch (err) {
  console.log("Error", err);
}
} catch (err) {
  console.log("Limit check error", err);
  alert("Something went wrong. Please try again.");
}
                                      }}
                                    >
                                      Book Now
                                    </Button>
                                  )}

                                  <Link
                                    to="#"
                                    className="btn btn-warning btn-sm"
                                    onClick={(e) => {
                                      e.preventDefault();

                                      localStorage.setItem(
                                        "SelectEvent",
                                        item._id,
                                      );
localStorage.setItem("SelectedEventData", JSON.stringify(item));
                                    //   localStorage.setItem(
                                    //     "SelectedEventMeta",
                                    //     JSON.stringify({
                                    //       _id: item._id,
                                    //       type: item.type,
                                    //       freeFoodType: item.freeFoodType,
                                    //     }),
                                    //   );

                                        nav("/EventsDetails");
                                    }}
                                  >
                                    Event Information
                                  </Link>
                                </div>
                              </div>
                            );
                          })}

                          <div className="border-top mt-5 pt-4 d-flex justify-content-center">
                            <Countdown
                              date={moment.parseZone(item.start_date).format()}
                              renderer={renderer}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <div className="text-center p-5">
            <h3 className="text-muted">No Upcoming Events to display.</h3>
          </div>
        )}
      </div>
      <Modal
        className="modal fade modal-wrapper auth-modal"
        show={modalMember}
        onHide={() => SetModalMember(false)}
        backdrop="static"
        centered
      >
        <h2 className="title text-white">Are you ?</h2>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
          }}
        >
          <div className="mb-3 col-12 col-sm-12">
            <fieldset className="d-flex flex-column">
              <div
                className="p-3 border-1 border-warning mb-3"
                style={{ borderRadius: 5 }}
              >
                <input
                  type="radio"
                  name="category"
                  className="me-2 form-check-input"
                  value="Member"
                  checked={validation.values.category === "Member"}
                  onChange={() =>
                    validation.setFieldValue("category", "Member")
                  }
                />
                <label className="me-3">Member</label>
              </div>
              <div
                className="p-3 border-1 border-warning mb-3"
                style={{ borderRadius: 5 }}
              >
                <input
                  type="radio"
                  name="category"
                  className="me-2 form-check-input"
                  value="Non-Member"
                  checked={validation.values.category === "Non-Member"}
                  onChange={() =>
                    validation.setFieldValue("category", "Non-Member")
                  }
                />
                <label className="me-3">Non-Member</label>
              </div>
            </fieldset>
            {validation.touched.category && validation.errors.category ? (
              <div
                style={{
                  fontSize: "12px",
                  color: "red",
                }}
              >
                {validation.errors.category}
              </div>
            ) : null}
          </div>

          <div className="row">
            <div className="col-6 ">
              <button
                className="btn btn-outline-danger btn-block"
                data-bs-toggle="collapse"
                onClick={() => {
                  SetModalMember(false);
                }}
              >
                Cancel
              </button>
            </div>
            <div className="col-6">
              <button
                className="btn btn-outline-primary btn-block"
                data-bs-toggle="collapse"
                type="submit"
              >
                Submit
              </button>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default TicketSlider;
